import { IconButton } from '@/components/ui/button';
import PatientDetail from './patientDetail/PatientDetail.tsx';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PatientDetailPanelProps {
  onClose: () => void;
  className?: string;
}

export function PatientDetailPanel({ onClose, className }: PatientDetailPanelProps) {
  return (
    <aside className={cn('surface-panel flex min-h-0 flex-col overflow-hidden', className)}>
      <header className="flex shrink-0 items-center justify-between gap-2 border-b border-white/6 px-3.5 py-2.5">
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-white/40">Patient overview</p>
        <IconButton
          onClick={onClose}
          variant="ghost-light"
          size="icon"
          className="h-8 w-8 rounded-lg"
          icon={X}
          aria-label="Close patient detail"
        />
      </header>
      <div className="relative z-10 flex min-h-0 flex-1 flex-col overflow-hidden p-3.5">
        <PatientDetail />
      </div>
    </aside>
  );
}
